module.exports = __webpack_public_path__ + "img/Progress2.fbe3ddc1.gif";